import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';

export async function getThucDonAnh(payload: {
    page: number;
    limit: number;
    cond?: any;
  }) {
    return axios.get(`${ip3}/thuc-don-anh/pageable`, {
      params: {
        ...payload,
        cond: {
          ...payload.cond,
        },
      },
    });
}

export async function addThucDonAnh(payload: any) {
  return axios.post(`${ip3}/thuc-don-anh`, payload);
}

export async function editThucDonAnh(payload: any) {
  const { id } = payload
  return axios.put(`${ip3}/thuc-don-anh/${id}`, payload)
}

export async function delThucDonAnh(payload: any) {
  const { id } = payload
  return axios.delete(`${ip3}/thuc-don-anh/${id}`)
}